import { Dispatch } from 'redux';
import { ORGANIZER_QUESTIONS_FORM_NAME } from '../constants';
import { SurveyFormData } from '../models/survey';
import { getFormValues } from '../selectors/forms';
import { getOrderId } from '../selectors/order/typedOrderSelectors';
import { getSurvey } from '../selectors/survey';
import { CheckoutState } from '../state';
import { updateOrderWithOptionalOrganizerQuestions } from './order/survey';

export const submitOptionalOrganizerQuestionsForm =
    (formData: SurveyFormData, skipErroredAnswers: boolean) =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const state = getState();
        const orderId = getOrderId(state);

        const formDataToSubmit =
            formData ?? getFormValues(state, ORGANIZER_QUESTIONS_FORM_NAME);

        const {
            preOrderConfirmationSurveySettings: {
                getStatistics,
                getAnswersPayloadForBackend,
            },
        } = getSurvey(state);

        const surveyAnswers = getAnswersPayloadForBackend(formDataToSubmit);

        const { statsigMetrics } = getStatistics(formData);

        await dispatch(
            updateOrderWithOptionalOrganizerQuestions(
                orderId,
                surveyAnswers,
                skipErroredAnswers,
                {
                    ...statsigMetrics,
                    currentPage: ORGANIZER_QUESTIONS_FORM_NAME,
                },
            ),
        );
    };
